module.exports = __webpack_public_path__ + "img/level_two_lock.13f7b9aa.png";